const REQUIRED_ARRAYS = ['transactions', 'recurring', 'sinkingFunds', 'debts'];

export function validateBudgetData(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  if (!REQUIRED_ARRAYS.every(key => Array.isArray(value[key]))) return false;
  if (!value.budgets || typeof value.budgets !== 'object' || Array.isArray(value.budgets)) return false;
  if (!value.settings || typeof value.settings !== 'object' || Array.isArray(value.settings)) return false;
  return true;
}

export function hasMeaningfulBudgetData(value) {
  if (!validateBudgetData(value)) return false;
  const untouchedBuiltInGoal = goal => {
    if (!goal || typeof goal !== 'object') return false;
    const emergency = goal.name === 'Emergency Fund' && goal.isEmergencyFund === true && goal.isInvestmentFund !== true;
    const investing = goal.name === 'Investing' && goal.isInvestmentFund === true && goal.isEmergencyFund !== true;
    return (emergency || investing)
      && Number(goal.goalAmount || 0) === 0
      && Number(goal.monthlyTarget || 0) === 0
      && Number(goal.saved || 0) === 0
      && Array.isArray(goal.contributions) && goal.contributions.length === 0
      && !goal.emergencyFundMonths
      && !goal.emergencyFundLastCalc;
  };
  return ['transactions', 'recurring', 'debts'].some(key => value[key].length > 0)
    || value.sinkingFunds.some(goal => !untouchedBuiltInGoal(goal))
    || Boolean(Array.isArray(value.deletedItems) && value.deletedItems.some(item => item && Date.now() - item.deletedAt >= 0 && Date.now() - item.deletedAt < 30 * 86400000))
    || Object.keys(value.budgets).length > 0
    || Boolean(value.settings.userName);
}

export function decideInitialSync({ localData, cloudSnapshot, metadata, userId }) {
  if (userId && metadata?.ownerUserId && metadata.ownerUserId !== userId) return 'foreign-local';
  if (metadata?.syncEnabled === false) return 'ready';
  const localMeaningful = hasMeaningfulBudgetData(localData);
  const cloudExists = Boolean(cloudSnapshot?.data && validateBudgetData(cloudSnapshot.data));

  if (!cloudExists && !localMeaningful) return 'ready-empty';
  if (!cloudExists && localMeaningful) return 'offer-upload';
  if (cloudExists && !localMeaningful) return 'offer-download';

  if (metadata?.ownerUserId && (!userId || metadata.ownerUserId === userId) && metadata?.cloudRevision === cloudSnapshot.revision) return 'ready';
  return 'resolve-existing-data';
}

export function createSyncMetadata(existing = {}) {
  return {
    ownerUserId: existing.ownerUserId || null,
    deviceId: existing.deviceId || crypto.randomUUID(),
    deviceLabel: existing.deviceLabel || defaultDeviceLabel(),
    cloudRevision: Number(existing.cloudRevision) || 0,
    pending: Boolean(existing.pending),
    syncEnabled: existing.syncEnabled !== false,
    lastSyncedAt: existing.lastSyncedAt || null,
    entitlementUserId: existing.entitlementUserId || null,
    entitlementVerifiedAt: existing.entitlementVerifiedAt || null
  };
}

export function defaultDeviceLabel(userAgent = globalThis.navigator?.userAgent || '') {
  if (/iPhone/i.test(userAgent)) return 'iPhone';
  if (/iPad/i.test(userAgent)) return 'iPad';
  if (/Android/i.test(userAgent)) return 'Android phone';
  if (/Macintosh|Mac OS/i.test(userAgent)) return 'Mac';
  if (/Windows/i.test(userAgent)) return 'Windows computer';
  return 'This device';
}
